/**
 * Global configuration variables.
 */
export default {
  // TODO Eliminar urls hardcodeadas
  DEBUG: process.env.NODE_ENV === 'development',
  BASE_URL: process.env.BASE_URL,

  CD_BACKEND_API_URL: process.env.VUE_APP_CD_BACKEND_API_URL,
  CD_BACKEND_API_KEY: process.env.VUE_APP_CD_BACKEND_API_KEY,
  CD_OPENPAY_ID: process.env.VUE_APP_CD_OPENPAY_ID,
  CD_OPENPAY_PUBLIC_KEY: process.env.VUE_APP_CD_OPENPAY_PUBLIC_KEY,
  CD_OPENPAY_IS_DEVELOPMENT: process.env.VUE_APP_CD_OPENPAY_IS_DEVELOPMENT,
  CD_STG_BASE_URL: process.env.VUE_APP_CD_STG_BASE_URL,
  CD_STG_ACCESS_KEY: process.env.VUE_APP_CD_STG_ACCESS_KEY,
  CD_GOOGLE_MAPS_API_KEY: process.env.VUE_APP_CD_GOOGLE_MAPS_API_KEY,
};
